/* tslint:disable */
/* eslint-disable */
/**
 * Akfen İnşaat Avocet Webapi
 * Akfen İnşaat Data Web Servis
 *
 * The version of the OpenAPI document: v1
 * Contact: support@rasyonet.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CardField
 */
export interface CardField {
    /**
     * 
     * @type {string}
     * @memberof CardField
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardField
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CardField
     */
    'order'?: number;
    /**
     * 
     * @type {number}
     * @memberof CardField
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface IndexWeightRow
 */
export interface IndexWeightRow {
    /**
     * 
     * @type {string}
     * @memberof IndexWeightRow
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IndexWeightRow
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface NavPoint
 */
export interface NavPoint {
    /**
     * 
     * @type {number}
     * @memberof NavPoint
     */
    'quarter'?: number;
    /**
     * 
     * @type {number}
     * @memberof NavPoint
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface NewsDetail
 */
export interface NewsDetail {
    /**
     * 
     * @type {string}
     * @memberof NewsDetail
     */
    'body'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsDetail
     */
    'id'?: string | null;
}
/**
 * 
 * @export
 * @interface NewsRow
 */
export interface NewsRow {
    /**
     * 
     * @type {string}
     * @memberof NewsRow
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsRow
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsRow
     */
    'header'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PriceChartPeriod = {
    OneWeek: 'OneWeek',
    OneMonth: 'OneMonth',
    ThreeMonth: 'ThreeMonth',
    SixMonth: 'SixMonth',
    OneYear: 'OneYear',
    TwoYear: 'TwoYear',
    ThreeYear: 'ThreeYear',
    FiveYear: 'FiveYear'
} as const;

export type PriceChartPeriod = typeof PriceChartPeriod[keyof typeof PriceChartPeriod];


/**
 * 
 * @export
 * @interface PricePoint
 */
export interface PricePoint {
    /**
     * 
     * @type {string}
     * @memberof PricePoint
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof PricePoint
     */
    'value'?: number;
}

/**
 * SnaphotApi - axios parameter creator
 * @export
 */
export const SnaphotApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotCardFieldsGet: async (symbolEntityId?: string, cultureCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snaphot/card-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (symbolEntityId !== undefined) {
                localVarQueryParameter['symbolEntityId'] = symbolEntityId;
            }

            if (cultureCode !== undefined) {
                localVarQueryParameter['cultureCode'] = cultureCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotIndexWeightGet: async (symbolEntityId?: string, cultureCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snaphot/index-weight`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (symbolEntityId !== undefined) {
                localVarQueryParameter['symbolEntityId'] = symbolEntityId;
            }

            if (cultureCode !== undefined) {
                localVarQueryParameter['cultureCode'] = cultureCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotNavChartGet: async (symbolEntityId?: string, currency?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snaphot/nav-chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (symbolEntityId !== undefined) {
                localVarQueryParameter['symbolEntityId'] = symbolEntityId;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [newsId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotNewsDetailGet: async (newsId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snaphot/news-detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (newsId !== undefined) {
                localVarQueryParameter['newsId'] = newsId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {string} [firstDate] 
         * @param {string} [lastdate] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotNewsGet: async (symbolEntityId?: string, cultureCode?: string, firstDate?: string, lastdate?: string, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snaphot/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (symbolEntityId !== undefined) {
                localVarQueryParameter['symbolEntityId'] = symbolEntityId;
            }

            if (cultureCode !== undefined) {
                localVarQueryParameter['cultureCode'] = cultureCode;
            }

            if (firstDate !== undefined) {
                localVarQueryParameter['firstDate'] = (firstDate as any instanceof Date) ?
                    (firstDate as any).toISOString() :
                    firstDate;
            }

            if (lastdate !== undefined) {
                localVarQueryParameter['lastdate'] = (lastdate as any instanceof Date) ?
                    (lastdate as any).toISOString() :
                    lastdate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {PriceChartPeriod} [period] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotPriceChartGet: async (symbolEntityId?: string, period?: PriceChartPeriod, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snaphot/price-chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (symbolEntityId !== undefined) {
                localVarQueryParameter['symbolEntityId'] = symbolEntityId;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SnaphotApi - functional programming interface
 * @export
 */
export const SnaphotApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SnaphotApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snaphotCardFieldsGet(symbolEntityId?: string, cultureCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CardField>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snaphotCardFieldsGet(symbolEntityId, cultureCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snaphotIndexWeightGet(symbolEntityId?: string, cultureCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IndexWeightRow>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snaphotIndexWeightGet(symbolEntityId, cultureCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snaphotNavChartGet(symbolEntityId?: string, currency?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NavPoint>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snaphotNavChartGet(symbolEntityId, currency, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [newsId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snaphotNewsDetailGet(newsId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snaphotNewsDetailGet(newsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {string} [firstDate] 
         * @param {string} [lastdate] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snaphotNewsGet(symbolEntityId?: string, cultureCode?: string, firstDate?: string, lastdate?: string, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsRow>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snaphotNewsGet(symbolEntityId, cultureCode, firstDate, lastdate, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {PriceChartPeriod} [period] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snaphotPriceChartGet(symbolEntityId?: string, period?: PriceChartPeriod, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PricePoint>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snaphotPriceChartGet(symbolEntityId, period, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SnaphotApi - factory interface
 * @export
 */
export const SnaphotApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SnaphotApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotCardFieldsGet(symbolEntityId?: string, cultureCode?: string, options?: any): AxiosPromise<Array<CardField>> {
            return localVarFp.snaphotCardFieldsGet(symbolEntityId, cultureCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotIndexWeightGet(symbolEntityId?: string, cultureCode?: string, options?: any): AxiosPromise<Array<IndexWeightRow>> {
            return localVarFp.snaphotIndexWeightGet(symbolEntityId, cultureCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [currency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotNavChartGet(symbolEntityId?: string, currency?: string, options?: any): AxiosPromise<Array<NavPoint>> {
            return localVarFp.snaphotNavChartGet(symbolEntityId, currency, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [newsId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotNewsDetailGet(newsId?: string, options?: any): AxiosPromise<NewsDetail> {
            return localVarFp.snaphotNewsDetailGet(newsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {string} [cultureCode] 
         * @param {string} [firstDate] 
         * @param {string} [lastdate] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotNewsGet(symbolEntityId?: string, cultureCode?: string, firstDate?: string, lastdate?: string, limit?: number, offset?: number, options?: any): AxiosPromise<Array<NewsRow>> {
            return localVarFp.snaphotNewsGet(symbolEntityId, cultureCode, firstDate, lastdate, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [symbolEntityId] 
         * @param {PriceChartPeriod} [period] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snaphotPriceChartGet(symbolEntityId?: string, period?: PriceChartPeriod, options?: any): AxiosPromise<Array<PricePoint>> {
            return localVarFp.snaphotPriceChartGet(symbolEntityId, period, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SnaphotApi - object-oriented interface
 * @export
 * @class SnaphotApi
 * @extends {BaseAPI}
 */
export class SnaphotApi extends BaseAPI {
    /**
     * 
     * @param {string} [symbolEntityId] 
     * @param {string} [cultureCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public snaphotCardFieldsGet(symbolEntityId?: string, cultureCode?: string, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).snaphotCardFieldsGet(symbolEntityId, cultureCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [symbolEntityId] 
     * @param {string} [cultureCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public snaphotIndexWeightGet(symbolEntityId?: string, cultureCode?: string, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).snaphotIndexWeightGet(symbolEntityId, cultureCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [symbolEntityId] 
     * @param {string} [currency] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public snaphotNavChartGet(symbolEntityId?: string, currency?: string, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).snaphotNavChartGet(symbolEntityId, currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [newsId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public snaphotNewsDetailGet(newsId?: string, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).snaphotNewsDetailGet(newsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [symbolEntityId] 
     * @param {string} [cultureCode] 
     * @param {string} [firstDate] 
     * @param {string} [lastdate] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public snaphotNewsGet(symbolEntityId?: string, cultureCode?: string, firstDate?: string, lastdate?: string, limit?: number, offset?: number, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).snaphotNewsGet(symbolEntityId, cultureCode, firstDate, lastdate, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [symbolEntityId] 
     * @param {PriceChartPeriod} [period] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SnaphotApi
     */
    public snaphotPriceChartGet(symbolEntityId?: string, period?: PriceChartPeriod, options?: AxiosRequestConfig) {
        return SnaphotApiFp(this.configuration).snaphotPriceChartGet(symbolEntityId, period, options).then((request) => request(this.axios, this.basePath));
    }
}



